import React, { useContext, useEffect, useState } from "react";

// React router dom
import { Routes, Route, Outlet, Navigate } from "react-router-dom";

// Css
import "./index.css";
import "./chart.css";
import "./step.css";

// Layout
import NavStruttura from "./layouts/nav/indexStruttura";
import NavSuperAdmin from "./layouts/nav/indexSuperAdmin";
import Footer from "./layouts/Footer";
import SidPageHeader from "./layouts/SidPageHeader";
import { PageHeaderExtraProvider } from "./layouts/PageHeaderExtra";
import Setting from "./layouts/Setting";
import { Button } from "react-bootstrap";
import { Danger } from "iconsax-react";
import { useNavigate, useLocation } from "react-router-dom";

// Pages
import ScrollToTop from "./layouts/ScrollToTop";
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import { useProfile } from "../hooks/useProfile";
import { ManagerSubscriptionProvider, useManagerSubscription } from "../context/ManagerSubscriptionContext";

// CUSTOM PAGES - STRUTTURA
import HomeStruttura                  from "./pages/struttura/dashboard";
import LaMiaStruttura                 from "./pages/struttura/lamiastruttura";
import Clienti                        from "./pages/struttura/anagrafiche/clienti";
import JuniorTable                    from "./pages/struttura/anagrafiche/junior";
import MaestriTable                   from "./pages/struttura/anagrafiche/maestri";
import VediMaestro                    from "./pages/struttura/anagrafiche/maestri/maestro_profile";
import ClubNatureGuard                from "./components/Util/ClubNatureGuard";
import { FunzioneAccesa }             from "./components/Util/FunzioneAccesa";
import { useSportsCatalogReady }      from "./components/Util/sportsCatalog";
import CdaTable                       from "./pages/struttura/anagrafiche/cda";
import ElencoAssemblee                from "./pages/struttura/assemblee";
import DettaglioAssemblea             from "./pages/struttura/assemblee/dettaglio";
import SchedaConsiglio                from "./pages/struttura/anagrafiche/cda/scheda";
import FirmaConsiglio                 from "./pages/struttura/anagrafiche/cda/firma";
import SociTable                      from "./pages/struttura/anagrafiche/soci";
import SchedaSocio                    from "./pages/struttura/anagrafiche/soci/scheda";
import AggiungiSocio                  from "./pages/struttura/anagrafiche/soci/aggiungi";
import TesseratiTable                 from "./pages/struttura/anagrafiche/tesserati";
import NuovoTesseramento              from "./pages/struttura/anagrafiche/tesserati/nuovo";
import SchedaTessera                  from "./pages/struttura/anagrafiche/tesserati/scheda";
import TeamsTable                     from "./pages/struttura/anagrafiche/teams";
import TeamsNew                       from "./pages/struttura/anagrafiche/teams/new";
import TeamsEdit                      from "./pages/struttura/anagrafiche/teams/edit";
import ComunicazioneGenericheLista    from "./pages/struttura/comunicazioni/generiche";
import ComunicazioneGenericheNuova    from "./pages/struttura/comunicazioni/generiche/new";
import ComunicazioneGenericheEdit     from "./pages/struttura/comunicazioni/generiche/edit";
import ComunicazioneInvitiLista       from "./pages/struttura/comunicazioni/inviti";
import ComunicazioneInvitiNuovo       from "./pages/struttura/comunicazioni/inviti/new";
import ComunicazioneInvitiEdit        from "./pages/struttura/comunicazioni/inviti/edit";
import StruttureDocumenti             from "./pages/struttura/documenti";
import StrutturaDocumentiNuovo        from "./pages/struttura/documenti/new";
import SchedaDocumentoStruttura       from "./pages/struttura/documenti/scheda";
import KitComunicazione from "./pages/struttura/kitcomunicazione/index";
import WikiPage from "./pages/struttura/wiki";

import GestioneAbbonamento from "./pages/struttura/abbonamento/GestioneAbbonamento";
import SchedaTransazioneAbbonamento from "./pages/struttura/abbonamento/SchedaTransazione";
import StrutturaCalendarioEventi      from "./pages/struttura/calendario/eventi";
import ListaProdotti                  from "./pages/struttura/prodotti/lista/listaprodotti";
import AddProdotto                    from "./pages/struttura/prodotti/lista/addProdotto";
import ListaImpianti                  from "./pages/struttura/prodotti/impianti/listaImpianti";
import AddImpianto                    from "./pages/struttura/prodotti/impianti/addImpianto";
import ListaPromo                     from "./pages/struttura/prodotti/promozioni/listaPromo";
import AddPromo                       from "./pages/struttura/prodotti/promozioni/addPromo";
import ListaDiAttesa                  from "./pages/struttura/prodotti/listaAttesa/listaDiAttesa";
import ReportLaMiaStruttura           from "./pages/struttura/report/reportStruttura";
import ReportStrutturaMaestri         from "./pages/struttura/report/reportMaestri";
import StrutturaUtenti                from "./pages/struttura/strumenti/struttureUtenti";
import StrutturaRuoli                 from "./pages/struttura/strumenti/struttureRuoli";
import StrutturaAddUtente             from "./pages/struttura/strumenti/struttureAddUtenteGestionale";
import StrutturaAddRuolo              from "./pages/struttura/strumenti/struttureAddRuolo";
import PlayerProfile                  from "./pages/struttura/anagrafiche/clienti/player_profile";
import AggiungiPlayerStruttura        from "./pages/struttura/anagrafiche/clienti/aggiungi";
import ImportaPlayerStruttura         from "./pages/struttura/anagrafiche/clienti/importa";
import AggiungiPlayerSingoloStruttura from "./pages/struttura/anagrafiche/clienti/aggiungiPlayer";
import AggiungiJuniorStruttura        from "./pages/struttura/anagrafiche/junior/aggiungi";
import JuniorProfile                  from "./pages/struttura/anagrafiche/junior/junior_profile";
import StrutturaRichieste             from "./pages/struttura/anagrafiche/richieste";
import SchedaRichiesta                from "./pages/struttura/anagrafiche/richieste/scheda";
import Impostazioni                   from "./pages/strumenti/impostazioni";
import ReferralStrutture              from "./pages/struttura/referral";
import PagamentoDonAction             from "./pages/struttura/referral/pagamento";
import ComingSoon                     from "./pages/struttura/comingsoon";
import Consulenza                     from "./pages/struttura/consulenza";
import Bilancio                       from "./pages/struttura/bilancio";

// CUSTOM PAGES - SUPERADMIN
import HomeSuperAdmin                 from "./pages/superadmin/dashboard";
import ListaStruttureSportive         from "./pages/superadmin/anagrafiche/strutture_sportive/index";
import StrutturaEdit                  from "./pages/superadmin/anagrafiche/strutture_sportive/edit";
import ListaPlayer                    from "./pages/superadmin/anagrafiche/player/index";
import PlayerEdit                     from "./pages/superadmin/anagrafiche/player/edit";
import ListaJunior                    from "./pages/superadmin/anagrafiche/junior/index";
import JuniorEdit                     from "./pages/superadmin/anagrafiche/junior/edit";
import ListaMaestri                   from "./pages/superadmin/anagrafiche/maestri/index";
import ListaDiscipline                from "./pages/superadmin/anagrafiche/discipline/index";
import TraguardiDisciplina            from "./pages/superadmin/anagrafiche/discipline/traguardi";
import SchedaDisciplina               from "./pages/superadmin/anagrafiche/discipline/scheda";
import OccorrenzaCorso               from "./pages/struttura/booking/courses/occorrenza";
import TicketPage                    from "./pages/ticket";
import TicketGraziePage              from "./pages/ticket/grazie";
import CorsiListPage                from "./pages/struttura/corsi";
import CorsiCorsoPage               from "./pages/struttura/corsi/corso";
import CorsiNuovoPartecipante       from "./pages/struttura/corsi/nuovoPartecipante";
import CorsiSquadrePage             from "./pages/struttura/corsi/squadre";
import CorsiSquadraDettaglio        from "./pages/struttura/corsi/squadraDettaglio";
import CorsiNuovoCorso              from "./pages/struttura/corsi/nuovoCorso";
import MaestroEdit                    from "./pages/superadmin/anagrafiche/maestri/edit";
import ListaAbilitazioneMaestri       from "./pages/superadmin/anagrafiche/abilitazione_maestri/listaAbilitazioneMaestri";
import ListaComunicazioni             from "./pages/superadmin/comunicazioni/index";
import AggiungiComunicazione          from "./pages/superadmin/comunicazioni/new";
import ModificaComunicazione          from "./pages/superadmin/comunicazioni/edit";
import ListaDocumenti                 from "./pages/superadmin/documenti/listaDocumenti";
import SchedaDocumentoDaValidare      from "./pages/superadmin/documenti/scheda";
import CalendarioEventi               from "./pages/superadmin/calendario/calendario_eventi/calendario_eventi";
import CalendarioPrenotazioni         from "./pages/superadmin/calendario/calendario_prenotazioni/calendario_prenotazioni";
import ListaProdottiSuperAdmin        from "./pages/superadmin/prodotti/prodotti/listaProdotti";
import ListaAttesa                    from "./pages/superadmin/prodotti/lista-attesa/listaAttesa";
import ListaPromozioni                from "./pages/superadmin/prodotti/promozioni/listaPromozioni";
import ReferralSuperAdmin             from "./pages/superadmin/referral";
import PagamentoDonActionAdmin        from "./pages/superadmin/referral/pagamento";
import ReportSportID                  from "./pages/superadmin/report/reportSportID";
import ReportStrutture                from "./pages/superadmin/report/reportStrutture";
import ReportMaestri                  from "./pages/superadmin/report/reportMaestri";
import ListaUtentiGestionale          from "./pages/superadmin/strumenti/utenti-gestionale/listaUtentiGestionale"; 
import AggiungiUtenteGestionale       from "./pages/superadmin/strumenti/utenti-gestionale/aggiungiUtentiGestionale";
import SubscriptionsTable             from "./pages/struttura/booking/subscriptions";
import UserSubscriptionsTable         from "./pages/struttura/booking/userSubscriptions";
import UserTransasctionsTable         from "./pages/struttura/booking/userTransactions";
import SubscriptionsNew               from "./pages/struttura/booking/subscriptions/new";
import SubscriptionsEdit              from "./pages/struttura/booking/subscriptions/edit";
import SubscriptionsView              from "./pages/struttura/booking/subscriptions/view";
import UserSubscriptionsNew           from "./pages/struttura/booking/userSubscriptions/new";
import UserSubscriptionsEdit          from "./pages/struttura/booking/userSubscriptions/edit";
import UserTransactionsEdit           from "./pages/struttura/booking/userTransactions/view";
import AdminUserSubscriptionsTable    from "./pages/superadmin/booking/userSubscriptions";
import AdminUserSubscriptionsEdit     from "./pages/superadmin/booking/userSubscriptions/edit";
import AdminSubscriptionsTable        from "./pages/superadmin/booking/subscriptions";
import AdminSubscriptionsEdit         from "./pages/superadmin/booking/subscriptions/edit";
import AdminUserTransasctionsTable    from "./pages/superadmin/booking/userTransactions";
import BillingRequests                from "./pages/superadmin/billing/requests";
import AdminUserTransactionsEdit      from "./pages/superadmin/booking/userTransactions/view";
import AdvIndex                       from "./pages/struttura/booking/adv";
import UserCoursesTeamsIndex          from "./pages/struttura/booking/userCoursesTeams";
import UserCoursesTeamsView           from "./pages/struttura/booking/userCoursesTeams/view";
import UserCoursesTeamsNew            from "./pages/struttura/booking/userCoursesTeams/new";
import UserCoursesTeamsEdit           from "./pages/struttura/booking/userCoursesTeams/edit";
import FacilitiesIndex                from "./pages/struttura/booking/facilities";
import FacilitiesNew                  from "./pages/struttura/booking/facilities/new";
import FacilitiesEdit                 from "./pages/struttura/booking/facilities/edit";
import FacilitiesCalendar             from "./pages/struttura/booking/facilities/calendar";
import UserVenuesNew                  from "./pages/struttura/booking/userFacilities/new";
import UserVenuesTable                from "./pages/struttura/booking/userFacilities";
import UserLessonsNew                 from "./pages/struttura/booking/userLessons/new";
import UserLessonsEdit                from "./pages/struttura/booking/userLessons/edit";
import UserVenuesEdit                 from "./pages/struttura/booking/userFacilities/edit";
import LessonsTable                   from "./pages/struttura/booking/lessons";
import LessonsCalendar                from "./pages/struttura/booking/lessons/calendar";
import LessonsNew                     from "./pages/struttura/booking/lessons/new";
import LessonsEdit                    from "./pages/struttura/booking/lessons/edit";
import LessonsEditMultiple            from "./pages/struttura/booking/lessons/edit-multiple";
import LessonsView                    from "./pages/struttura/booking/lessons/view";
import LinkAcquistoListPage           from "./pages/struttura/link";
import UserLessonsIndex               from "./pages/struttura/booking/userLessons";
import CoursesTable                   from "./pages/struttura/booking/courses";
import UserCoursesTable               from "./pages/struttura/booking/userCourses";
import SalesTable                     from "./pages/struttura/booking/sales";
import CoursesNew                     from "./pages/struttura/booking/courses/new";
import CoursesNewClosed               from "./pages/struttura/booking/courses/newclosed";
import CoursesEdit                    from "./pages/struttura/booking/courses/edit";
import CoursesEditClosed              from "./pages/struttura/booking/courses/editclosed";
import CoursesView                    from "./pages/struttura/booking/courses/view";
import CoursesViewClosed              from "./pages/struttura/booking/courses/viewclosed";
import UserCoursesNew                 from "./pages/struttura/booking/userCourses/new";
import UserCoursesEdit                from "./pages/struttura/booking/userCourses/edit";
import AdminUserCoursesTable          from "./pages/superadmin/booking/userCourses";
import AdminUserCoursesEdit           from "./pages/superadmin/booking/userCourses/edit";
import AdminCoursesTable              from "./pages/superadmin/booking/courses";
import AdminCoursesEdit               from "./pages/superadmin/booking/courses/edit";
import AdminUserCoursesTeamsIndex     from "./pages/superadmin/booking/userCoursesTeams";
import AdminUserCoursesTeamsView      from "./pages/superadmin/booking/userCoursesTeams/view";
import AdminFacilitiesIndex           from "./pages/superadmin/booking/facilities";
import AdminFacilitiesEdit            from "./pages/superadmin/booking/facilities/edit";
import AdminUserFacilitiesTable       from "./pages/superadmin/booking/userFacilities";
import AdminUserFacilitiesView        from "./pages/superadmin/booking/userFacilities/view";
import AdminUserLessonsTable          from "./pages/superadmin/booking/userLessons";
import AdminUserLessonsView           from "./pages/superadmin/booking/userLessons/view";
import AdminLessonsTable              from "./pages/superadmin/booking/lessons/index";
import AdminLessonsView               from "./pages/superadmin/booking/lessons/view";

// SUPERADMIN - MANAGER SUBSCRIPTIONS
import ManagerSubscriptionsList from "./pages/superadmin/manager-subscriptions/index";
import ManagerSubscriptionsSettings from "./pages/superadmin/manager-subscriptions/settings";
import ManagerSubscriptionScheda from "./pages/superadmin/manager-subscriptions/scheda";

// SUPERADMIN - STRUMENTI
import DebugFatture from "./pages/superadmin/strumenti/debugFatture";

// ABBONAMENTO
import AbbonamentoPage from "./pages/struttura/abbonamento/AbbonamentoPage";
import SuccessPage from "./pages/struttura/abbonamento/SuccessPage";
import CancelPage from "./pages/struttura/abbonamento/CancelPage";
import ExpiredPage from "./pages/struttura/abbonamento/ExpiredPage";
import InactivePage from "./pages/struttura/abbonamento/InactivePage";
import ListaPagineParlanti from "./pages/superadmin/pagine-parlanti/index";
import ListaCertificati from "./pages/struttura/certificati/index";
import SollecitiCertificati from "./pages/superadmin/strumenti/sollecitiCertificati";
import PostaInUscita from "./pages/superadmin/strumenti/postaInUscita";
import VersioneApp from "./pages/superadmin/strumenti/versioneApp";
import Funzioni from "./pages/superadmin/strumenti/funzioni";
import ListaPagineApp from "./pages/superadmin/pagine-app/index";
import SchedaPaginaApp from "./pages/superadmin/pagine-app/scheda";
import ListaVideoPresentazione from "./pages/superadmin/video-presentazione/index";
import SchedaVideoPresentazione from "./pages/superadmin/video-presentazione/scheda";
import SchedaCertificato from "./pages/struttura/certificati/scheda";
import SchedaPaginaParlante from "./pages/superadmin/pagine-parlanti/scheda";
import { ConColonnaParlante } from "./components/PaginaParlante/ColonnaParlante";
import { MenuImpostazioni, isPaginaImpostazioni } from "./layouts/MenuImpostazioni";

const Markup = () => {

  const allroutes = [

    // CUSTOM ROUTES - STRUTTURA
    { url: "struttura/dashboard", component: <HomeStruttura/> },
    { url: "struttura/lamiastruttura", component: <LaMiaStruttura/> },
    { url: "struttura/clienti/list", component: <Clienti/> },
    { url: "struttura/clienti/aggiungi", component: <AggiungiPlayerStruttura/> },
    { url: "struttura/clienti/invita", component: <AggiungiPlayerStruttura/> },
    { url: "struttura/clienti/importa", component: <ImportaPlayerStruttura/> },
    { url: "struttura/clienti/nuovo", component: <AggiungiPlayerSingoloStruttura/> },
    { url: "struttura/clienti/player_profile/:id", component:<PlayerProfile/>},
    { url: "struttura/junior/list", component: <JuniorTable/> },
    { url: "struttura/junior/nuovo", component: <AggiungiJuniorStruttura/> },
    { url: "struttura/junior/junior_profile/:id", component: <JuniorProfile/>},
    { url: "struttura/maestri/list", component: <MaestriTable/> },
    { url: "struttura/richieste", component: <StrutturaRichieste/> },
    { url: "struttura/richieste/:id", component: <SchedaRichiesta/> },
    { url: "struttura/cda/list", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><CdaTable/></ClubNatureGuard> },
    { url: "struttura/cda/scheda", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><SchedaConsiglio/></ClubNatureGuard> },
    { url: "struttura/cda/scheda/:id", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><SchedaConsiglio/></ClubNatureGuard> },
    { url: "struttura/cda/firma/:id", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><FirmaConsiglio/></ClubNatureGuard> },
    // Modulo Assemblee dietro feature flag REACT_APP_FEATURE_ASSEMBLEE: quando è
    // disattivo l'URL resta lo stesso e mostra Coming Soon, così la voce di menu
    // non diventa un link morto e riattivarlo è solo un cambio di .env.
    { url: "struttura/assemblee", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><FunzioneAccesa chiave="assemblies" altrimenti={<ComingSoon/>}><ElencoAssemblee/></FunzioneAccesa></ClubNatureGuard> },
    { url: "struttura/assemblee/:id", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><FunzioneAccesa chiave="assemblies" altrimenti={<ComingSoon/>}><DettaglioAssemblea/></FunzioneAccesa></ClubNatureGuard> },
    { url: "struttura/soci/list", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><SociTable/></ClubNatureGuard> },
    { url: "struttura/soci/scheda/:id", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><SchedaSocio/></ClubNatureGuard> },
    { url: "struttura/soci/aggiungi", component: <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><AggiungiSocio/></ClubNatureGuard> },
    { url: "struttura/tesserati/list", component: <ClubNatureGuard allow={['ASD','SSD']}><TesseratiTable/></ClubNatureGuard> },
    { url: "struttura/tesserati/nuovo", component: <ClubNatureGuard allow={['ASD','SSD']}><NuovoTesseramento/></ClubNatureGuard> },
    { url: "struttura/tesserati/scheda/:id", component: <ClubNatureGuard allow={['ASD','SSD']}><SchedaTessera/></ClubNatureGuard> },
    { url: "struttura/teams/list", component: <TeamsTable/> },
    { url: "struttura/teams/add", component: <TeamsNew/> },
    { url: "struttura/teams/edit/:id", component: <TeamsEdit/> },
    { url: "struttura/comunicazioni/generiche", component: <ComunicazioneGenericheLista/>},
    { url: "struttura/comunicazioni/generiche/add", component: <ComunicazioneGenericheNuova/>},
    { url: "struttura/comunicazioni/generiche/:id", component: <ComunicazioneGenericheEdit/>},
    { url: "struttura/comunicazioni/inviti", component: <ComunicazioneInvitiLista/>},
    { url: "struttura/comunicazioni/inviti/add", component:<ComunicazioneInvitiNuovo/>},
    { url: "struttura/comunicazioni/inviti/:id", component: <ComunicazioneInvitiEdit/>},
    { url: "struttura/documenti", component:<StruttureDocumenti/>},
    { url: "struttura/documenti/add", component:<StrutturaDocumentiNuovo/>},
    { url: "struttura/documenti/scheda/:id", component:<SchedaDocumentoStruttura/>},
    { url: "struttura/kitcomunicazione", component:<KitComunicazione/>},
    { url: "struttura/calendario/eventi", component:<StrutturaCalendarioEventi/>},
    { url: "struttura/maestri/maestro_profile/:id", component:<VediMaestro/>},
    { url: "struttura/prodotti/lista/", component:<ListaProdotti/>},
    { url: "struttura/prodotti/lista/aggiungi", component:<AddProdotto/>},
    { url: "struttura/prodotti/impianti/lista", component:<ListaImpianti/>},
    { url: "struttura/prodotti/impianti/aggiungi", component:<AddImpianto/>},
    { url: "struttura/prodotti/promozioni", component:<ListaPromo/>},
    { url: "struttura/prodotti/promozioni/aggiungi", component:<AddPromo/>},
    { url: "struttura/prodotti/listaAttesa", component:<ListaDiAttesa/>},
    { url: "struttura/report/reportStruttura", component:<ReportLaMiaStruttura/>},
    { url: "struttura/report/reportMaestri", component: <ReportStrutturaMaestri/>},
    { url: "struttura/strumenti/utenti", component:<StrutturaUtenti/>},
    { url: "struttura/strumenti/ruoli", component:<StrutturaRuoli/>},
    { url: "struttura/strumenti/aggiungi_utente", component:<StrutturaAddUtente/>},
    { url: "struttura/strumenti/aggiungi_ruolo", component:<StrutturaAddRuolo/>},
    { url: 'struttura/wiki', component:<WikiPage/>},
    { url: 'struttura/account', component:<Impostazioni/>},
    { url: 'struttura/strumenti/impostazioni', component:<Navigate to="/struttura/account" replace />},
    { url: 'struttura/strumenti/abbonamento-info', component:<GestioneAbbonamento/>},
    { url: 'struttura/strumenti/abbonamento-info/transazione/:id', component:<SchedaTransazioneAbbonamento/>},
    { url: "struttura/referral", component: <ReferralStrutture /> },
    { url: "struttura/referral/pagamento/:da", component: <PagamentoDonAction /> },
    { url: "struttura/comingsoon", component: <ComingSoon /> },
    // Ticket di assistenza (widget LUME) aperto dentro il Manager
    { url: "struttura/ticket", component: <TicketPage /> },
    { url: "superadmin/ticket", component: <TicketPage /> },
    { url: "struttura/ticket/grazie", component: <TicketGraziePage /> },
    { url: "superadmin/ticket/grazie", component: <TicketGraziePage /> },
    // FitCoin: pagine proprie (ognuna con il suo titolo e la sua voce di menu attiva), per ora "in arrivo"
    { url: "struttura/fitcoin/wallet", component: <ComingSoon /> },
    { url: "struttura/fitcoin/promozioni", component: <ComingSoon /> },
    { url: "struttura/link", component: <LinkAcquistoListPage /> },
    { url: "struttura/certificati", component: <ListaCertificati /> },
    { url: "struttura/certificati/:id", component: <SchedaCertificato /> },
    { url: "struttura/consulenza", component: <Consulenza /> },
    { url: "struttura/bilancio", component: <Bilancio /> },
    { url: "struttura/booking/subscriptions", component: <SubscriptionsTable /> },
    { url: "struttura/booking/sales", component: <SalesTable /> },
    { url: "struttura/booking/userTransactions", component: <UserTransasctionsTable /> },
    { url: "struttura/booking/subscriptions/new", component: <SubscriptionsNew /> },
    { url: "struttura/booking/subscriptionsedit/:id", component:<SubscriptionsEdit/>},
    { url: "struttura/booking/subscriptionsview/:id", component:<SubscriptionsView/>},
    { url: "struttura/booking/userSubscriptions/new", component: <UserSubscriptionsNew /> },
    { url: "struttura/booking/userSubscriptions/:id", component:<UserSubscriptionsEdit/>},
    { url: "struttura/booking/adv", component: <AdvIndex /> },
    { url: "struttura/booking/userCoursesTeams", component: <UserCoursesTeamsIndex /> },
    { url: "struttura/booking/userCoursesTeams/view/:id", component: <UserCoursesTeamsView /> },
    { url: "struttura/booking/userCoursesTeams/edit/:id", component: <UserCoursesTeamsEdit /> },
    { url: "struttura/booking/userCoursesTeams/new", component: <UserCoursesTeamsNew /> },
    { url: "struttura/booking/facilities", component: <FacilitiesIndex /> },
    { url: "struttura/booking/facilities/new", component: <FacilitiesNew /> },
    { url: "struttura/booking/facilitiesedit/:id", component: <FacilitiesEdit /> },
    { url: "struttura/booking/facilities/calendar", component: <FacilitiesCalendar /> },
    { url: "struttura/booking/userFacilities", component: <UserVenuesNew /> },
    { url: "struttura/booking/userLessons", component: <UserLessonsNew /> },
    { url: "struttura/booking/userLessons/:id", component: <UserLessonsEdit /> },
    { url: "struttura/booking/uservenues/:id", component: <UserVenuesEdit /> },
    { url: "struttura/booking/lessons", component: <LessonsTable /> },
    { url: "struttura/booking/lessons/calendar", component: <LessonsCalendar /> },
    { url: "struttura/booking/lessons/new", component: <LessonsNew /> },
    { url: "struttura/booking/lessonsedit/:id", component: <LessonsEdit /> },
    { url: "struttura/booking/lessonseditmultiple/:id", component: <LessonsEditMultiple /> },
    { url: "struttura/booking/lessonsview/:id", component: <LessonsView /> },

    { url: "struttura/booking/userTransactions/:id", component:<UserTransactionsEdit/>},
    { url: "struttura/booking/courses", component: <CoursesTable /> },
    // Corsi: la nuova gestione dei corsi con più squadre, che sostituisce le pagine in booking/courses
    { url: "struttura/corsi", component: <CorsiListPage /> },
    { url: "struttura/corsi/:id", component: <CorsiCorsoPage /> },
    { url: "struttura/corsi/:id/squadre/:squadraId", component: <CorsiCorsoPage /> },
    { url: "struttura/corsi/:id/partecipanti/nuovo", component: <CorsiNuovoPartecipante /> },
    { url: "struttura/corsi/partecipanti/nuovo", component: <CorsiNuovoPartecipante /> },
    { url: "struttura/corsi/nuovo", component: <CorsiNuovoCorso /> },
    { url: "struttura/corsi/squadre", component: <CorsiSquadrePage /> },
    { url: "struttura/corsi/squadre/:id", component: <CorsiSquadraDettaglio /> },
    { url: "struttura/booking/courses/occorrenza/:id", component: <OccorrenzaCorso /> },

    { url: "struttura/booking/courses/new", component: <CoursesNew /> },
    { url: "struttura/booking/courses/newclosed", component: <CoursesNewClosed /> },
    { url: "struttura/booking/coursesedit/:id", component:<CoursesEdit/>},
    { url: "struttura/booking/courseseditclosed/:id", component:<CoursesEditClosed/>},
    { url: "struttura/booking/coursesview/:id", component:<CoursesView/>},
    { url: "struttura/booking/coursesviewclosed/:id", component:<CoursesViewClosed/>},
    { url: "struttura/booking/userCourses/new", component: <UserCoursesNew /> },
    { url: "struttura/booking/userCourses/:id", component:<UserCoursesEdit/>},

    // ABBONAMENTO
    { url: "abbonamento", component: <AbbonamentoPage /> },
    { url: "abbonamento/success", component: <SuccessPage /> },
    { url: "abbonamento/cancel", component: <CancelPage /> },
    { url: "abbonamento/expired", component: <ExpiredPage /> },
    { url: "abbonamento/inactive", component: <InactivePage /> },

    // CUSTOM ROUTES - SUPERADMIN
    { url: "superadmin/dashboard", component: <HomeSuperAdmin /> },
    { url: "superadmin/anagrafiche/strutture-sportive", component: <ListaStruttureSportive /> },
    { url: "superadmin/anagrafiche/strutture-sportive/:id", component: <StrutturaEdit /> },
    { url: "superadmin/anagrafiche/player", component: <ListaPlayer /> },
    { url: "superadmin/anagrafiche/player/:id", component: <PlayerEdit /> },
    { url: "superadmin/anagrafiche/junior", component: <ListaJunior /> },
    { url: "superadmin/anagrafiche/junior/:id", component: <JuniorEdit /> },
    { url: "superadmin/anagrafiche/maestri", component: <ListaMaestri /> },
    { url: "superadmin/anagrafiche/maestri/:id", component: <MaestroEdit /> },
    { url: "superadmin/anagrafiche/abilitazione-maestri", component: <ListaAbilitazioneMaestri /> },
    { url: "superadmin/anagrafiche/discipline", component: <ListaDiscipline /> },
    { url: "superadmin/anagrafiche/discipline/nuova", component: <SchedaDisciplina /> },
    { url: "superadmin/anagrafiche/discipline/:code", component: <SchedaDisciplina /> },
    { url: "superadmin/anagrafiche/discipline/:code/traguardi", component: <TraguardiDisciplina /> },
    { url: "superadmin/comunicazioni", component: <ListaComunicazioni /> },
    { url: "superadmin/pagine-parlanti", component: <ListaPagineParlanti /> },
    { url: "superadmin/pagine-parlanti/:id", component: <SchedaPaginaParlante /> },
    { url: "superadmin/comunicazioni/add", component: <AggiungiComunicazione /> },
    { url: "superadmin/comunicazioni/:id", component: <ModificaComunicazione /> },
    { url: "superadmin/documenti", component: <ListaDocumenti /> },
    { url: "superadmin/documenti/scheda/:id", component: <SchedaDocumentoDaValidare /> },
    { url: "superadmin/calendario/calendario-eventi", component: <CalendarioEventi /> },
    { url: "superadmin/calendario/calendario-prenotazioni", component: <CalendarioPrenotazioni /> },
    { url: "superadmin/prodotti", component: <ListaProdottiSuperAdmin /> },
    { url: "superadmin/prodotti/promozioni", component: <ListaPromozioni /> },
    { url: "superadmin/prodotti/lista-di-attesa", component: <ListaAttesa /> },
    { url: "superadmin/referral", component: <ReferralSuperAdmin /> },
    { url: "superadmin/referral/pagamento/:id/:da", component: <PagamentoDonActionAdmin /> },
    { url: "superadmin/report/sportid", component: <ReportSportID /> },
    { url: "superadmin/report/strutture", component: <ReportStrutture /> },
    { url: "superadmin/report/maestri", component: <ReportMaestri /> },
    { url: "superadmin/strumenti/utenti-gestionale", component: <ListaUtentiGestionale /> },
    { url: "superadmin/strumenti/aggiungi-utente-gestionale", component: <AggiungiUtenteGestionale /> },
    { url: 'superadmin/account', component:<Impostazioni/>},
    { url: 'superadmin/strumenti/impostazioni', component:<Navigate to="/superadmin/account" replace />},
    { url: 'superadmin/strumenti/certificati-medici', component: <SollecitiCertificati /> },
    { url: 'superadmin/strumenti/posta-in-uscita', component: <PostaInUscita /> },
    { url: 'superadmin/strumenti/versione-app', component: <VersioneApp /> },
    { url: 'superadmin/strumenti/funzioni', component: <Funzioni /> },
    { url: 'superadmin/pagine-app', component: <ListaPagineApp /> },
    { url: 'superadmin/pagine-app/:slug', component: <SchedaPaginaApp /> },
    { url: 'superadmin/video-presentazione', component: <ListaVideoPresentazione /> },
    { url: 'superadmin/video-presentazione/:clubId', component: <SchedaVideoPresentazione /> },
    { url: 'superadmin/strumenti/debug-fatture', component:<DebugFatture/>},
    { url: "superadmin/booking/subscriptions", component: <AdminSubscriptionsTable /> },
    { url: "superadmin/booking/userSubscriptions", component: <AdminUserSubscriptionsTable /> },
    { url: "superadmin/booking/userTransactions", component: <AdminUserTransasctionsTable /> },
    { url: "superadmin/billing/requests", component: <BillingRequests /> },
    { url: "superadmin/booking/subscriptions/:id", component:<AdminSubscriptionsEdit/>},
    { url: "superadmin/booking/userSubscriptions/:id", component:<AdminUserSubscriptionsEdit/>},
    { url: "superadmin/booking/userTransactions/:id", component:<AdminUserTransactionsEdit/>},
    { url: "superadmin/booking/courses", component: <AdminCoursesTable /> },
    { url: "superadmin/booking/userCourses", component: <AdminUserCoursesTable /> },
    { url: "superadmin/booking/courses/:id", component:<AdminCoursesEdit/>},
    { url: "superadmin/booking/userCourses/:id", component:<AdminUserCoursesEdit/>},
    { url: "superadmin/booking/userCoursesTeams", component: <AdminUserCoursesTeamsIndex /> },
    { url: "superadmin/booking/userCoursesTeams/view/:id", component: <AdminUserCoursesTeamsView /> },
    { url: "superadmin/booking/facilities", component: <AdminFacilitiesIndex /> },
    { url: "superadmin/booking/facilitiesedit/:id", component: <AdminFacilitiesEdit /> },
    { url: "superadmin/booking/userFacilities", component: <AdminUserFacilitiesTable /> },
    { url: "superadmin/booking/userFacilities/:id", component: <AdminUserFacilitiesView /> },
    { url: "superadmin/booking/lessons", component: <AdminLessonsTable /> },
    { url: "superadmin/booking/lessons/:id", component: <AdminLessonsView /> },
    { url: "superadmin/booking/userLessons", component: <AdminUserLessonsTable /> },
    { url: "superadmin/booking/userLessons/:id", component: <AdminUserLessonsView /> },

    // SUPERADMIN - MANAGER SUBSCRIPTIONS
    { url: "superadmin/manager-subscriptions", component: <ManagerSubscriptionsList /> },
    { url: "superadmin/manager-subscriptions/settings", component: <ManagerSubscriptionsSettings /> },
    { url: "superadmin/manager-subscriptions/scheda/:id", component: <ManagerSubscriptionScheda /> },
  ];

  return (
    <ManagerSubscriptionProvider>
      <Routes>
        <Route path='/' element={<HomeRedirect />} />
        <Route path='page-lock-screen' element={<LockScreen />} />
        <Route path='page-error-400' element={<Error400 />} />
        <Route path='page-error-403' element={<Error403 />} />
        <Route path='page-error-404' element={<Error404 />} />
        <Route path='page-error-500' element={<Error500 />} />
        <Route path='page-error-503' element={<Error503 />} />
        <Route element={<MainLayout />} >
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
        <Route path='*' element={<Navigate to="/" replace />} />
      </Routes>
      <Setting />
      <ScrollToTop />
    </ManagerSubscriptionProvider>
  );
};

function MainLayout() {

  const userType = sessionStorage.getItem('userType');
  // console.log(userType);

  const { menuToggle } = useContext(ThemeContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [inactiveShowed, setInactiveShowed] = useState(false);
  const { profile } = useProfile();
  const { subscription, loading } = useManagerSubscription();
  // Il catalogo delle discipline arriva dal server e i 67 file che usano `sports` lo
  // leggono da un array mutato sul posto: mutare un array non fa ri-renderizzare React,
  // percio' l'attesa va fatta qui, prima del primo render. Non fallisce mai: al massimo
  // si prosegue con l'elenco compilato.
  const sportsReady = useSportsCatalogReady();
  
  useEffect(() => {
    if (userType === 'struttura' && profile && profile.club && profile.club.profileStatus === 'INACTIVE') {
      setInactiveShowed(true);
    }
  }, [userType, profile]);

  if (!sportsReady || (userType === 'struttura' && loading)) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  // Prevent rendering content if not active and not on abbonamento page (context will redirect)
  if (userType === 'struttura' && subscription && !subscription.active && !location.pathname.startsWith('/abbonamento')) {
    return null;
  }

  const isAbbonamentoPage = location.pathname.startsWith('/abbonamento');
  const inImpostazioni = isPaginaImpostazioni(userType, location.pathname);

  const getDaysRemaining = (endDateStr) => {
    if (!endDateStr) return null;
    const end = new Date(endDateStr + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return Math.floor((end.getTime() - today.getTime()) / 86400000);
  };

  const daysRemaining = subscription ? getDaysRemaining(subscription.endDate) : null;
  const isTrialSubscription = subscription && subscription.active && subscription.status === 'active' && subscription.priceEur === 0;
  const showExpiringBanner = subscription && subscription.active && !isTrialSubscription && daysRemaining !== null && daysRemaining <= 30 && daysRemaining > 0;
  const isFreeSubscription = subscription && subscription.status === 'free';
  const formatDateIt = (dateStr) => {
    if (!dateStr) return '';
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
  };

  return (
    <PageHeaderExtraProvider>
    <div id="main-wrapper" className={`show ${menuToggle ? "menu-toggle" : ""}`}>
      {userType === 'struttura' && !isAbbonamentoPage && <NavStruttura />}
      {userType === 'superadmin' && <NavSuperAdmin />}
      <div className={isAbbonamentoPage ? "content-body p-0 m-0" : "content-body"} style={{ minHeight: window.screen.height - 45 }}>
        {/* I banner stanno dentro il container-fluid: fuori avevano solo mt-1/mx-1
            (4px) contro i 2.5rem del contenuto, e finivano appiccicati all'header. */}
        <div className="container-fluid">
          {showExpiringBanner && userType === 'struttura' && (
            <div className="row">
              <div className="col-xl-12">
                <div className="card" style={{ backgroundColor: '#ffc107', color: '#000' }}>
                  <div className="card-header border-0 flex-wrap flex-column align-content-start align-items-baseline p-3">
                    <h4 className="fs-18 font-w500 mb-2 text-dark">
                      <Danger style={{ marginRight: '10px' }} size='20'></Danger>
                      {isFreeSubscription
                        ? `Il tuo abbonamento scadrà il ${formatDateIt(subscription.endDate)}.`
                        : `Il tuo abbonamento si rinnoverà automaticamente il ${formatDateIt(subscription.endDate)}. Assicurati che la tua carta di credito sia valida.`}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          )}
          {inactiveShowed && userType === 'struttura' && !isAbbonamentoPage && (
            <div className="row">
              <div className="col-xl-12">
                <div className="card" style={{ backgroundColor: '#FD7E14', color: '#fff' }}>
                  <div className="card-header border-0 d-flex flex-wrap align-items-center justify-content-between" style={{ gap: '18px' }}>
                    <div>
                      <h4 className="fs-24 font-w500 mb-3 text-white"><Danger style={{ marginRight: '18px' }} size='24'></Danger>Il profilo non è attivo</h4>
                      <div>Inserisci le informazioni mancanti, valida il profilo e attiva la struttura nei risultati di ricerca di SportId!</div>
                    </div>
                    <Button onClick={() => navigate('/struttura/lamiastruttura')} className="custom-button">Completa il profilo</Button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* Pagine di impostazione: menu intermedio a sinistra (come LUME), sul telefono pulsanti in cima */}
          <div className={inImpostazioni ? 'sid-impostazioni' : undefined}>
          {inImpostazioni && <MenuImpostazioni userType={userType} />}
          <div className={inImpostazioni ? 'sid-impostazioni__pagina' : undefined}>
          {inImpostazioni && <MenuImpostazioni userType={userType} perTelefono />}
          {!isAbbonamentoPage && location.pathname !== '/struttura/dashboard' && <SidPageHeader />}
          {/* Colonna destra «parlante» (testo scritto dal super admin in Pagine parlanti), solo lato Struttura */}
          <ConColonnaParlante pathname={location.pathname} attivo={userType === 'struttura' && !isAbbonamentoPage}>
            <Outlet />
          </ConColonnaParlante>
          </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
    </PageHeaderExtraProvider>
  )
};

export default Markup;
function HomeRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    const userType = sessionStorage.getItem('userType');
    if (userType === 'struttura' || userType === 'superadmin') {
      navigate(`/${userType}/dashboard`, { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);
  return null;
}